export default __webpack_public_path__ + "static/media/bgRaster.20d57edb.png";